<template>
    <div class="product-button-overlay__container">
        <div class="home-block-overlay__container__gradient" ref="gradient_container" :style="loadingGradient">
            <canvas ref="home_block_gradient" class="product-button-overlay-canvas"></canvas>
        </div>
    </div>

</template>
<script>

    import Config from 'assets/js/site/_site-config';
    import Granim from 'granim';

    export default{

        data: function(){
            return {
                gradientAnimation: null,
            }
        },

        mounted: function(){
            this.initializeGradient();
        },

        methods: {
            initializeGradient: function() {
                this.gradientAnimation = new Granim({
                    element: this.$refs.home_block_gradient,
                    name: 'granim',
                    direction: 'top-bottom', // 'diagonal', 'top-bottom'
                    opacity: [1, 1, 1],
                    isPausedWhenNotInView: true,
                    scrollDebounceThreshold: 300,
                    states : {
                        "default-state": {
                            gradients: Config.gradients,
                            transitionSpeed: 2000,
                            loop: true
                        }
                    }
                })
            },
        },

        computed: {
            loadingGradient: function() {
                const gradient = Config.gradients[0];

                return {
                    "background": `linear-gradient(${gradient[0]}, ${gradient[1]}, ${gradient[2]})`
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

    .product-button-overlay-canvas{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .product-button-overlay__container{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/bhf-filter/product-button-gradient.vue